// components/AccreditationBar.jsx
import React from 'react';

const AccreditationBar = () => {
  const items = ['NABL Registered Lab', 'Certified Pathologists', 'Online Report Delivery', 'Home Sample Collection'];
  
  return (
    <div className="bg-teal-light border-y border-[#c5e8e3] py-4 px-8">
      <div className="max-w-[1200px] mx-auto flex items-center justify-center gap-8 flex-wrap">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2 text-sm font-semibold text-teal-dark">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccreditationBar;